import type { ReactNode } from "react";
import { useAuth } from "@/hooks/useAuth";

export function AuthGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center bg-background-50">
        <span className="w-8 h-8 flex items-center justify-center text-foreground-400">
          <i className="ri-loader-4-line text-2xl animate-spin"></i>
        </span>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login using Vite's define constant for base path
    if (typeof window !== "undefined") {
      const basePath = __BASE_PATH__ || "";
      window.location.href = `${basePath}/clinic-login`;
    }
    return null;
  }

  return <>{children}</>;
}
